// Styling
// import style from "./button.module.scss";

export default function Button(props) {
  const {
    id,
    className,
    onClick,
    state,
    type,
    disabled,
    btnStyle,
    ariaAtts,
    dataAtts,
  } = props;

  // TODO: automatic open/close for aria-label in relation to state?

  //   function containsWord(str, word) {
  //     return str.match(new RegExp("\\b" + word + "\\b")) != null;
  //   }
  //   const isGlobalBtn = containsWord("btn", className);

  const btnAtts = {
    // className: isGlobalBtn ? className + " " + style.btn : className,
    id,
    className,
    onClick: onClick,
    state: state,
    type: type,
    disabled: disabled,
    style: btnStyle,
    ...ariaAtts,
    ...dataAtts,
  };

  return <button {...btnAtts}>{props.children}</button>;
}
